import React from 'react'
import LoginPageContainer from '../containers/LoginPageContainer'
import GuestGuardContainer from '../containers/GuestGuardContainer'

function LoginPageScreen() {
  return (
    // <GuestGuardContainer>
    <LoginPageContainer />
    // </GuestGuardContainer>
  )
}

export default LoginPageScreen
